module.exports = __webpack_public_path__ + "img/type10130.9bf2e4b0.png";